/**
 * Vertical layout component.
 * Provides layout structure with sidebar, navbar, content, and footer.
 * Based on Vuexy VerticalLayout component.
 */

// React Imports
import type { ReactNode } from 'react';

// Third-party Imports
import classnames from 'classnames';

// Type Imports
import type { ChildrenType } from '@core/types';

// Component Imports
import LayoutContent from './components/vertical/LayoutContent';

// Util Imports
import { verticalLayoutClasses } from './utils/layoutClasses';

// Styled Component Imports
import StyledContentWrapper from './styles/vertical/StyledContentWrapper';

type VerticalLayoutProps = ChildrenType & {
  navigation?: ReactNode;
  navbar?: ReactNode;
  footer?: ReactNode;
};

/**
 * Vertical layout component
 */
const VerticalLayout = (props: VerticalLayoutProps) => {
  // Props
  const { navbar, footer, navigation, children } = props;

  return (
    <div className={classnames(verticalLayoutClasses.root, 'flex flex-auto')}>
      {navigation || null}
      <StyledContentWrapper
        className={classnames(verticalLayoutClasses.contentWrapper, 'flex flex-col min-is-0 is-full')}
      >
        {navbar || null}
        {/* Content */}
        <LayoutContent>{children}</LayoutContent>
        {footer || null}
      </StyledContentWrapper>
    </div>
  );
};

export default VerticalLayout;
